// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SurveyQuestion {
    static getAttributeTypeMap() {
        return SurveyQuestion.attributeTypeMap;
    }
}
SurveyQuestion.discriminator = undefined;
SurveyQuestion.attributeTypeMap = [
    {
        "name": "key",
        "baseName": "key",
        "type": "string"
    },
    {
        "name": "answers",
        "baseName": "answers",
        "type": "Array<SurveyAnswer>"
    }
];
//# sourceMappingURL=surveyQuestion.js.map